import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import { getAllClubsCodes, getAllEventsByClub, getAllStadiumsCodes, getAllPriceBandsCodes, getTicketsCompareData, getAllAreaCodes } from "../../fetchers/RFIDTickets";
import rootStores from "../../stores";
import DataTable from "../../components/table/Table";
import { getColumns } from "./consts";
import { useTranslation } from "react-i18next";

const RFIDTicketsStore = rootStores.RFIDTicketsStore;

const TicketsCompareComponent = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language as "he" | "en";

  useEffect(() => {
    fetchFiltersData();
  }, []);

  useEffect(() => {
    fetchEventsByClub();
  }, [RFIDTicketsStore.club]);

  const fetchEventsByClub = () => {
    getAllEventsByClub(RFIDTicketsStore.club?.clubPrefix).then(events => {
      RFIDTicketsStore.setEvents(events);
    }).catch(console.error);
  }
  const fetchFiltersData = () => {
    getAllAreaCodes().then(areas => {
      RFIDTicketsStore.setAreas(areas);
      RFIDTicketsStore.setAllAreasCodes(areas);
    }).catch(console.error);
    
    getAllStadiumsCodes().then(stadiums => {
      RFIDTicketsStore.setStadiums(stadiums);
      RFIDTicketsStore.setAllStadiumsCodes(stadiums);
    }).catch(console.error);
    
    getAllPriceBandsCodes().then(priceBands => {
      RFIDTicketsStore.setPriceBands(priceBands);
    }).catch(console.error);
    
    fetchEventsByClub();
  
    getAllClubsCodes().then(clubs => {
      RFIDTicketsStore.setClubs(clubs);
      RFIDTicketsStore.setAllClubsCodes(clubs);
      RFIDTicketsStore.setFilterField('clubPrefix', RFIDTicketsStore.club ? RFIDTicketsStore.club.clubPrefix : clubs[0]?.clubPrefix);
      RFIDTicketsStore.setClub(RFIDTicketsStore.club ? RFIDTicketsStore.club : clubs[0]);
    }).catch(console.error);
  }

  const [rowsData, setRowsData] = useState<[]>([]);
  const [pageSize, setPageSize] = useState<number>(100);
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [evaXMLTicketsLength, setEvaXMLTicketsLength] = useState<number | null>(null);
  const [fortressTicketsLength, setFortressTicketsLength] = useState<number | null>(null);

  const handleFilter = async () => {
    if (!RFIDTicketsStore.filter.event) {
      alert(t("ticketsCompare.selectEventError"));
      return;
    }

    setIsTableLoading(true);

    const res = await getTicketsCompareData(
      RFIDTicketsStore.club,
      RFIDTicketsStore.filter.event
    );

    const differentObjects = res?.differentObjects.map(
      (obj: any, index: number) => ({ ...obj, id: index })
    );

    setRowsData(differentObjects);
    setEvaXMLTicketsLength(res.evaXMLTicketsLength);
    setFortressTicketsLength(res.fortressTicketsLength);
    setTotalRecords(differentObjects.length);
    setPageSize(differentObjects.length + 1);
    setIsTableLoading(false);
  };

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "row-reverse" }}>
      <div
        style={{
          margin: "30px 50px 0 50px",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <Header
          handleFilter={handleFilter}
          isRightDialogOpen={true}
          filterFields={["event"]}
        />

        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <div style={{ display: "flex", margin: "2vh" }}>
            {evaXMLTicketsLength !== null && (
              <div style={{ margin: "0 4vh" }}>
                {t("ticketsCompare.evaXmlCount")} : {evaXMLTicketsLength}
              </div>
            )}

            {fortressTicketsLength !== null && (
              <div style={{ margin: "0 4vh" }}>
                {t("ticketsCompare.fortressCount")} : {fortressTicketsLength}
              </div>
            )}
          </div>
        </div>

        <DataTable
          rows={rowsData}
          columns={getColumns(language)}
          isLoading={isTableLoading}
          withCheckbox={false}
          withAllCheckbox={false}
          pageSize={pageSize}
          setPageSize={setPageSize}
          totalRecordsInDB={totalRecords}
        />
      </div>
    </div>
  );
};

export default TicketsCompareComponent;
